<script setup>
import { onMounted, defineProps, getCurrentInstance, ref, computed, watch } from 'vue';
import request from "@/service/request";
import {getCityListByCityName, getCityListPingYin} from "@/service/api";

let instance;

let cityList = [
    {name:"北京", code: "110100"},
    {name:"上海", code: "310100"},
    {name:"广州", code: "440100"},
    {name:"天津", code: "120100"},
    {name:"苏州", code: "320500"},
    {name:"成都", code: "510100"},
    {name:"重庆", code: "500100"},
    {name:"郑州", code: "410100"},
    {name:"武汉", code: "420100"},
    {name:"杭州", code: "330100"},
]

let cityName = ref('');
let showCityPannel = ref(false);
let pyList = ref({});
// let pyCityList = ref([]);
let currentPy = ref("");
let searchInputText = ref("");
let searchInputList = ref([]);
let showSearchList = ref(false);

const props = defineProps({
    modelValue: {
        type: String
    },
    cityName:{
        type: String
    }
})

const searchCityHandler = async (city) => {
    let {data} = await request({
        url: getCityListByCityName,
        data: {
            cityname: city
        }
    })

    let cityData = data[0];

    instance.emit('update:modelValue', cityData.trueCityCode);
    cityName.value = city;
    triggleShowPannel(false);
}

const searchCityListHandler = async (city) => {
    let {data} = await request({
        url: getCityListByCityName,
        data: {
            cityname: city
        }
    })

    searchInputList.value = data;
    showSearchList.value = true;
}

const triggleShowPannel = (flag) => {
    showCityPannel.value = flag;
}

const changePyItem = item => {
    // pyCityList.value = pyList.value[item];
    currentPy.value = item;
}

const fuzzyQueryHandler = (item) => {
    instance.emit('update:modelValue', item.cityCode);
    cityName.value = item.name;
    showSearchList.value = false;
    searchInputText.value = "";
    triggleShowPannel(false);
}

watch(() => props.modelValue, (newValue) => {
    if(props.modelValue == ""){
        cityName.value = "";
    }
})

onMounted(async () => {
    let current = cityList.find(item => item.code == props.modelValue);
    if(current){
        cityName.value = current.name;
    }
    if(props.cityName) {
        cityName.value = props.cityName;
    }
    instance = getCurrentInstance();
    let {data} = await request({
        url: getCityListPingYin
    })
    pyList.value = data;

})

const gotoScrollTop = (text) => {
    let parentEl = document.getElementById('Js_cityPySearchList');
    let el = document.getElementById(text);
    parentEl.scrollTop = el.offsetTop - 10;
}
</script>
<template>
    <div class="city-select-box" id="Js_citySelectBox">
        <div class="city-select-control" @click="triggleShowPannel(true)">
            <div class="iconfont icon-dingwei city-select-icon"></div>
            <span class="city-select-text">{{ cityName }}</span>
        </div>

        <div class="city-select-pannel" v-show="showCityPannel">
            <div class="city-close-btn"  @click="triggleShowPannel(false)"><span class="iconfont icon-guanbi0"></span></div>
            <p class="city-top-text">城市列表</p>
            <div class="city-top-list">
                <span v-for="item in cityList" :key="item.code" @click="searchCityHandler(item.name)">{{ item.name }}</span>
            </div>
            <div class="city-top-input">
                <div class="city-input-box">
                    <el-input size="small" v-model="searchInputText"></el-input>
                    <ul class="city-input-search-list" v-show="showSearchList">
                        <li v-for="item in searchInputList" :key="item.cityCode" @click="fuzzyQueryHandler(item)">{{ item.name }}</li>
                    </ul>
                </div>
                <el-button size="small" type="primary" class="city-search-btn" @click="searchCityListHandler(searchInputText)">搜索</el-button>
            </div>
            <div class="city-py-sort">
                <div class="city-py-list">
                    <a href="javascript:;" v-for="item in Object.keys(pyList)" :key="item" :class="{'city-py-current': currentPy == item}" @click="gotoScrollTop(item)">{{ item }}</a>
                </div>

                <div class="city-py-search-list" id="Js_cityPySearchList" style="position: relative;">
                    <div class="city-py-search-item" :id="item" v-for="item in Object.keys(pyList)" :key="item">
                        <a class="city-py-first-word">{{ item }}</a>
                        <div class="city-py-fw-citylist">
                            <span v-for="cl in pyList[item]" :key="cl.cityCode" @click="searchCityHandler(cl.name)">{{ cl.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<style lang="less" scoped>
.city-select-box {
    position: relative;
    z-index: 9;
    line-height: 20px;
}

.city-select-pannel{
    position: absolute;
    background: #fff;
    padding: 10px;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    width: 300px;
    top: 42px;
}
.city-select-control{
    //border: 1px solid #dcdfe6;
    border: 0;
    border-radius: 4px;
    height: 36px;
    display: flex;
    align-items: center;
    padding: 0 10px 0 0;
    box-sizing: border-box;
    cursor: pointer;
}
.city-select-control .city-select-icon{
    font-size: 26px;
    color: #1378D7;
}

.city-select-control .city-select-text{
    white-space: nowrap;
}
.city-top-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
}

.city-top-list span {
    margin-right: 6px;
    white-space: nowrap;
    cursor: pointer;
    color: #409eff;
}

.city-top-input {
    display: flex;
    margin: 10px 0;
}

.city-top-input .city-search-btn {
    margin-left: 10px;
}

.city-py-list {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
}

.city-py-list a {
    margin-right: 6px;
    cursor: pointer;
    color: #409eff;
    text-decoration: none;
}

.city-py-list span.city-py-current{
    color: #1477C9;
}

.city-close-btn {
    position: absolute;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    right: 5px;
    top: 5px;
}

.city-close-btn span {
    font-size: 12px;
    cursor: pointer;
}

.city-py-search-item{
    display: flex;
    margin-top: 10px;
}

.city-py-search-item .city-py-first-word{
    font-size: 30px;
    line-height: 30px;
    color: #ccc;
    width: 40px;
    flex-shrink: 0;
}

.city-py-search-item .city-py-fw-citylist{
}

.city-py-search-list{
    max-height: 200px;
    overflow: auto;
}

.city-py-search-list span{
    margin-right: 6px;
    white-space: nowrap;
    cursor: pointer;
    color: #8f8d8d;
}

.city-input-box{
    width: 100%;
    position: relative;
}

.city-input-search-list{
    position: absolute;
    width: 100%;
    background: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    max-height: 200px;
    overflow: auto;
}

.city-input-search-list li{
    padding: 0 5px;
    box-sizing: border-box;
    line-height: 24px;
    border-bottom: 1px solid #dcdfe6;
    cursor: pointer;
}
.city-input-search-list li:hover{
    color: #fff;
    background-color: #409eff;
}
</style>